import httpClient from '@/utilities/service/httpClient'
import AbstractApi from '@/api/abstracts/AbstractApi'
// Types
import { FinancePayloadType } from '@/api/types/request/FinancePayloadType'
import { FinanceMonthlyType, FinanceType } from '@/api/types/response/FinanceType'

/**
 * @property string apiEnd /api/finance/wip
 */
export default class FinanceApi extends AbstractApi {
  summary({ year }: FinancePayloadType): Promise<FinanceType> {
    const url = this.apiEnd + (year ? `/${year}` : '')
    return httpClient.get(url)
  }

  monthly({ month, year }: FinancePayloadType): Promise<FinanceMonthlyType> {
    const url = this.apiEnd + (year ? `/${year}` : '') + (month ? `/${month}` : '')
    return httpClient.get(url)
  }
}
